const loadImg = (src) => new Promise((res, rej) => {
  const i = new Image();
  i.crossOrigin = "anonymous";
  i.onload = () => res(i);
  i.onerror = rej;
  i.src = src;
});

export async function removeBackground(src, tol = 42) {
  const img = await loadImg(src);
  const max = 1200;
  const k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
  const w = Math.round(img.naturalWidth * k), h = Math.round(img.naturalHeight * k);
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const ctx = c.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  const d = ctx.getImageData(0, 0, w, h);
  const p = d.data;
  const corners = [0, w - 1, (h - 1) * w, h * w - 1];
  const bg = [0, 1, 2].map((ch) => corners.reduce((s, i) => s + p[i * 4 + ch], 0) / 4);
  const dist = (i) => Math.max(Math.abs(p[i * 4] - bg[0]), Math.abs(p[i * 4 + 1] - bg[1]), Math.abs(p[i * 4 + 2] - bg[2]));
  const seen = new Uint8Array(w * h);
  const stack = [];
  for (let x = 0; x < w; x++) { stack.push(x, (h - 1) * w + x); }
  for (let y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
  while (stack.length) {
    const i = stack.pop();
    if (seen[i]) continue;
    if (dist(i) > tol) continue;
    seen[i] = 1;
    const x = i % w, y = (i / w) | 0;
    if (x > 0) stack.push(i - 1);
    if (x < w - 1) stack.push(i + 1);
    if (y > 0) stack.push(i - w);
    if (y < h - 1) stack.push(i + w);
  }
  for (let i = 0; i < w * h; i++) {
    if (seen[i]) { p[i * 4 + 3] = 0; continue; }
    const x = i % w, y = (i / w) | 0;
    const edge = (x > 0 && seen[i - 1]) || (x < w - 1 && seen[i + 1]) || (y > 0 && seen[i - w]) || (y < h - 1 && seen[i + w]);
    if (edge) p[i * 4 + 3] = Math.min(p[i * 4 + 3], Math.round(255 * Math.min(1, dist(i) / (tol * 2.5))));
  }
  ctx.putImageData(d, 0, 0);
  return new Promise((res) => c.toBlob(res, "image/png"));
}
